import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { formatarDiaCapitalizadoUTC } from "../FiltroAcompanhamentoOperacional/utils";

export const formatDate = (dateString: string) => {
  if (!dateString) return "";
  const dateOnly = dateString.split("T")[0];
  const safeDate = new Date(`${dateOnly}T12:00:00Z`);

  return format(safeDate, "dd MMM", { locale: ptBR });
};

type InputItem = {
  properties: {
    id: string;
    codigo: string;
    tamanhoAreaHa: string;
    operacoes: any[];
    fill: string;
    planosoperacionais: {
      DataProgramada: string;
      PeriodoDataInicio: string;
      PeriodoDataFim: string;
      Operacao: string;
      OperacaoClasse: string;
      OperacaoId: string;
    }[];
  };
};

export type OutputItem = {
  id: string;
  codigo: string;
  date: string;
  operacoesQtde: number;
  talhoesQtde: number;
  tamanhoAreaHa: number;
  color: string;
  colorBackend: string;
  dateOriginal: string;
  dateComplete: string;
  periodoDataInicio: string;
  periodoDataFim: string;
  colorBackendWindow: string;
  operacao: string;
  operacaoClasse: string;
  operacaoId: string;
};

export const normalizeAndGroupByDate = (
  data: InputItem[],
  datasWithColor: any[],
  opt: boolean = false
): OutputItem[] => {
  if (!data) return [];
  const map = new Map<string, OutputItem>();
  data.forEach(item => {
    const area = Number(item.properties.tamanhoAreaHa);
    const operacoesQtde = item.properties.operacoes.length;
    const talhoesQtde = item.properties.planosoperacionais.length;

    item.properties.planosoperacionais.forEach(plano => {
      if (!plano.DataProgramada) return;
      const dayKey = plano.DataProgramada?.slice(0, 10);
      const mapKey = `${dayKey}-${item.properties.codigo}`;

      const option = opt ? dayKey : mapKey;

      if (map.has(option)) {
        const existing = map.get(option)!;
        existing.tamanhoAreaHa += area;
        existing.operacoesQtde += operacoesQtde;
        existing.talhoesQtde += talhoesQtde;
      } 
      else {
        map.set(option, {
          id: item.properties.id,
          date: plano.DataProgramada,
          dateOriginal: plano.DataProgramada,
          periodoDataInicio: plano.PeriodoDataInicio,
          periodoDataFim: plano.PeriodoDataFim,
          dateComplete: formatarDiaCapitalizadoUTC(plano.DataProgramada),
          operacoesQtde,
          talhoesQtde,
          operacao: plano.Operacao,
          operacaoClasse: plano.OperacaoClasse,
          operacaoId: plano.OperacaoId,
          tamanhoAreaHa: area,
          codigo: item.properties.codigo,
          color: setColor(datasWithColor, plano.DataProgramada),
          colorBackend: operacoesQtde > 1 ? setColor(datasWithColor, plano.DataProgramada) : item.properties.fill,
          colorBackendWindow: item.properties.fill,
        });
      }
    });
  });

  return Array.from(map.values()).sort(
    (a, b) =>
      new Date(a.date).getTime() - new Date(b.date).getTime()
  ).map(item =>
  ({
    ...item,
    tamanhoAreaHa: Number(item.tamanhoAreaHa.toFixed(2)),
    date: formatDate(item.date)
  }));
};

function setColor(datasWithColor: any[], date: string) {
  const dateSelected = datasWithColor?.find((item: any) =>
    item?.dataProgramada === date?.slice(0, 10)
  )

  if (!dateSelected) return '';

  return dateSelected?.color;
}
